/**
 * Paleta única de colores para etiquetas de WhatsApp.
 *
 * Fuente canónica — todos los componentes que rendericen tags deben
 * importar de aquí para mantener consistencia visual entre:
 *   - Lista de chats (WaConversationList)
 *   - Sidebar de navegación (WaInboxNavigation)
 *   - Panel de acciones (WaConversationActionsPanel)
 *   - Modal "Etiquetar chat" (WaLabelModal)
 *   - Header del chat (WaChatHeader)
 *   - Página Etiquetas (WaTagManager)
 */

export type WaTagColor =
  | 'gray'
  | 'black'
  | 'red'
  | 'deepOrange'
  | 'orange'
  | 'amber'
  | 'yellow'
  | 'lime'
  | 'lightGreen'
  | 'green'
  | 'teal'
  | 'cyan'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink';

/** Hex canónico por color (paleta Material tipo Chatwoot, ordenada por espectro). */
export const WA_TAG_COLORS: Record<WaTagColor, string> = {
  gray: '#9e9e9e',
  black: '#424242',
  red: '#ef5350',
  deepOrange: '#ff7043',
  orange: '#ff9800',
  amber: '#ffb300',
  yellow: '#fbc02d',
  lime: '#c0ca33',
  lightGreen: '#7cb342',
  green: '#43a047',
  teal: '#00897b',
  cyan: '#00acc1',
  blue: '#1e88e5',
  indigo: '#3949ab',
  purple: '#8e24aa',
  pink: '#ec407a',
};

/** Opciones para selector de color (Polaris Select / botones). */
export const WA_TAG_COLOR_OPTIONS: Array<{ label: string; value: WaTagColor }> = [
  { label: 'Gris', value: 'gray' },
  { label: 'Negro', value: 'black' },
  { label: 'Rojo', value: 'red' },
  { label: 'Naranja intenso', value: 'deepOrange' },
  { label: 'Naranja', value: 'orange' },
  { label: 'Ámbar', value: 'amber' },
  { label: 'Amarillo', value: 'yellow' },
  { label: 'Lima', value: 'lime' },
  { label: 'Verde claro', value: 'lightGreen' },
  { label: 'Verde', value: 'green' },
  { label: 'Turquesa', value: 'teal' },
  { label: 'Cian', value: 'cyan' },
  { label: 'Azul', value: 'blue' },
  { label: 'Índigo', value: 'indigo' },
  { label: 'Morado', value: 'purple' },
  { label: 'Rosa', value: 'pink' },
];

/** Resuelve hex. Acepta clave simbólica ('blue') o HEX ('#1e88e5'). Default = gray. */
export function waTagColorHex(color: string | null | undefined): string {
  if (!color) return WA_TAG_COLORS.gray;
  if (/^#[0-9a-fA-F]{3,8}$/.test(color)) return color;
  return (WA_TAG_COLORS as Record<string, string>)[color] ?? WA_TAG_COLORS.gray;
}
